import { buttonVariants } from "@my-saas/ui";
import { cn } from "@my-saas/utils";
import { motion } from "framer-motion";
import { Link } from "react-router";

import { Logo } from "@/client/components/logo";
import { useAuthStore } from "@/client/stores/auth";

import { DonationBanner } from "./donation-banner";

export const Header = () => {
  const isLoggedIn = useAuthStore((state) => !!state.user);

  return (
    <motion.header
      className="fixed inset-x-0 top-0 z-20"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0, transition: { delay: 0.3, duration: 0.3 } }}
    >
      <DonationBanner />

      <div className="bg-gradient-to-b from-background to-transparent py-3" dir="rtl">
        <div className="container flex items-center justify-between">
          <Link to="/" className="flex items-center" aria-label="cig.chat">
            <Logo size={36} />
          </Link>

          <nav className="flex items-center gap-x-1">
            <Link
              to="/#how-it-works"
              className={cn(buttonVariants({ variant: "ghost", size: "sm" }))}
            >
              איך זה עובד
            </Link>
            <Link
              to="/#pricing"
              className={cn(buttonVariants({ variant: "ghost", size: "sm" }))}
            >
              מחירים
            </Link>
            <Link
              to="/contact"
              className={cn(buttonVariants({ variant: "ghost", size: "sm" }))}
            >
              צרו קשר
            </Link>
            <Link
              to={isLoggedIn ? "/dashboard" : "/auth/login"}
              className={cn(buttonVariants({ variant: "ghost", size: "sm" }))}
            >
              {isLoggedIn ? "ניהול" : "כניסה"}
            </Link>
            <Link
              to={isLoggedIn ? "/dashboard/onboarding/create-tenant" : "/auth/register"}
              className={cn(buttonVariants({ variant: "primary", size: "sm" }))}
            >
              {isLoggedIn ? "הוספת ארגון" : "הרשמה חינם"}
            </Link>
          </nav>
        </div>
      </div>
    </motion.header>
  );
};
